<template>
  <div class="help-root">

    <div class="help-intro">
      <span class="material-symbols-outlined help-hero-icon">groups</span>
      <p>
        Gestiona las interconsultas recibidas: revisa las solicitudes enviadas
        por otros médicos, consulta el motivo y cuadro clínico, y accede al
        formulario para registrar la respuesta.
      </p>
    </div>

    <!-- Búsqueda -->
    <section class="help-section">
      <h3 class="help-section-title">
        <span class="material-symbols-outlined">search</span>
        Búsqueda de interconsultas
      </h3>
      <div class="help-cards">
        <div class="help-card" v-for="item in busquedas" :key="item.titulo">
          <span class="material-symbols-outlined help-card-icon">{{ item.icon }}</span>
          <div>
            <p class="help-card-title">{{ item.titulo }}</p>
            <p class="help-card-desc">{{ item.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Estados -->
    <section class="help-section">
      <h3 class="help-section-title">
        <span class="material-symbols-outlined">info</span>
        Estados de una interconsulta
      </h3>
      <div class="help-estados">
        <span
          v-for="e in estados"
          :key="e.label"
          class="help-estado-badge"
          :style="{ background: e.color, color: e.text }"
        >{{ e.label }}</span>
      </div>
    </section>

    <!-- Opciones por fila -->
    <section class="help-section">
      <h3 class="help-section-title">
        <span class="material-symbols-outlined">touch_app</span>
        Opciones por interconsulta
      </h3>
      <div class="help-actions">
        <div class="help-action" v-for="a in acciones" :key="a.titulo">
          <span class="material-symbols-outlined help-action-icon" :style="{ color: a.color }">{{ a.icon }}</span>
          <div>
            <p class="help-card-title">{{ a.titulo }}</p>
            <p class="help-card-desc">{{ a.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <div class="help-tip">
      <span class="material-symbols-outlined">lightbulb</span>
      <p>
        Al ingresar se cargan automáticamente todas las interconsultas
        asignadas al médico en sesión. Usa <strong>Edición/Detalles</strong>
        para registrar la respuesta clínica de la interconsulta recibida.
      </p>
    </div>

  </div>
</template>

<script>
export default {
  name: "AyudaInterconsulta",
  data() {
    return {
      busquedas: [
        {
          icon: "person_search",
          titulo: "Por nombre",
          desc:   "Escribe el nombre del paciente o médico y presiona Enter o el botón Buscar para filtrar los resultados.",
        },
        {
          icon: "auto_awesome_motion",
          titulo: "Todos los registros",
          desc:   "Pulsa el botón de lista para recargar todas las interconsultas del médico en sesión sin aplicar filtros.",
        },
      ],
      estados: [
        { label: "SOLICITADA", color: "#ffecb3", text: "#7a5800" },
        { label: "ASIGNADA",   color: "#b3e5fc", text: "#014361" },
        { label: "PROCESO",    color: "#c8e6c9", text: "#1b5e20" },
        { label: "RECHAZADA",  color: "#ef9a9a", text: "#7f0000" },
        { label: "FINALIZADA", color: "#a5d6a7", text: "#1b5e20" },
      ],
      acciones: [
        {
          icon:   "summarize",
          color:  "#0059cc",
          titulo: "Resumen",
          desc:   "Muestra un resumen de la interconsulta: médico solicitante, paciente, motivo y cuadro clínico.",
        },
        {
          icon:   "edit_note",
          color:  "#198754",
          titulo: "Edición / Detalles",
          desc:   "Abre el formulario de respuesta de la interconsulta para registrar los hallazgos, diagnóstico y recomendaciones del médico consultado.",
        },
      ],
    };
  },
};
</script>

<style src="@/assets/css/ayuda.css" scoped></style>